import { getCurrentInstance, toRefs } from 'vue'

// Access the reactive MSAL state installed by msalPlugin. Must be called
// from within a component's setup().
export function useMsal () {
  const internalInstance = getCurrentInstance()
  if (!internalInstance) {
    throw new Error('useMsal() must be called within a component setup function')
  }

  const msalState = internalInstance.appContext.config.globalProperties.$msal
  if (!msalState) {
    throw new Error('msalPlugin is not installed on this app')
  }

  const { instance, accounts, permissions } = toRefs(msalState)

  return {
    instance: instance.value,
    accounts,
    permissions,
  }
}
